import React, { useState, useEffect } from "react";
import axios from "axios";
import Live from "../../../../../../assets/images/instagram-live 1.png";
import AllDataHeader from "../../../../../Reuseable/AllDataHeader";
import AllModuleData from "../../../../../Reuseable/AllModuleData";
import LoaderPost from "../../../../../Reuseable/LoaderPost";

const LiveMeetUp = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/meetup_event/live`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Live Meetup Events" image={Live} count={count} />
      {buffer ? (
        <LoaderPost />
      ) : (
      <AllModuleData
        data={event_data}
        urlLink={`/superstar-admin/meetup-events/details`}
      />
      )}
    </>
  );
};

export default LiveMeetUp;
